import React, { ReactNode, useEffect, useRef, useState } from "react"
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon"
import { ScreenHeader, ScreenIngress } from "../UI/Elements"
import { LanguageCodeType, PlantTranslationType, SnippetsType, TranslateTextObjType, TranslateTextOptions, TranslationStateType, TranslationStateTypeText, TranslationStatusType, TranslationStatusTypeText, useTranslationsManager } from "./useTranslationsManager";
import Select from 'react-select';
import { Overlay } from "../UI/Overlay";
import { Config } from "../../Config";
import { StringHelper } from "../../Handlers/Helpers";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { HasRole } from "../UI/RoleElements";

export const TranslationsManager = () => {

    const ops = useTranslationsManager();

    useEffect(() => {
        ops.load();
    }, [, ops.plantTypeId]);


    const show_field_name = ops.selectedFields.indexOf("name") >= 0;
    const show_field_specifictype = ops.selectedFields.indexOf("specifictype") >= 0;
    const show_field_public_description = ops.selectedFields.indexOf("public_description") >= 0;
    const show_field_snippet = ops.selectedFields?.[0]?.startsWith("snippet");

    const filteredRows = ops.dataFiltered;
    const [visibleRows, setVisibleRows] = useState<PlantTranslationType[]>([]);

    const [pageCurrentIndex, setPageCurrentIndex] = useState<number>(0);
    const [pageCount, setPageCount] = useState<number>(50);

    const [totalPageCount, setTotalPageCount] = useState<number>(0);
    const [totalItemCount, setTotalItemCount] = useState<number>(0);

    useEffect(() => {
        setTotalItemCount(filteredRows?.length);
        setTotalPageCount(Math.ceil(filteredRows?.length / pageCount));
        setPageCurrentIndex(0);
    }, [filteredRows, pageCount]);

    useEffect(() => {
        const calculatedRows = filteredRows.slice(
            pageCurrentIndex * pageCount,
            (pageCurrentIndex + 1) * pageCount
        );
        setVisibleRows(calculatedRows);
    }, [, pageCurrentIndex, totalItemCount]);

    const onShowNotTranslatedSnippets = (language: LanguageCodeType) => {
        ops.filterToSnippetsWithoutTranslations(ops.selected_snippet_fieldname, language);
    }

    return (
        <div className="translations-screen">
            <form onSubmit={e => e.preventDefault()}>
                <Overlay visible={ops.loading} />
                <ScreenHeader text="Översättningar" icon={AdminIcons.language} />
                <ScreenIngress>
                    Översättningsstatus kommer från den automatiska översättningen. vanligtvis 'ok' men ibland 'needs_review'. <br />
                    Egen status sätter du själv. från början har alla 'Ingen'. Sedan kan man ändra till det man vill.


                    <HasRole role={"DEVELOPER"}>
                        <div>
                            {JSON.stringify({
                                show_field_name: show_field_name,
                                show_field_specifictype: show_field_specifictype,
                                show_field_snippet: show_field_snippet,
                                selectedFields: ops.selectedFields
                            })}
                        </div>
                    </HasRole>
                </ScreenIngress>

                {/****************************************** TOOLBOX *******************************************/}
                <div className="toolbox">
                    <div>
                        <label>filtrera namn</label><br />
                        <input type="text" onChange={e => ops.filterName(e.target.value)} />
                    </div>
                    <div style={{ minWidth: "350px" }}>
                        <label>Typ</label>

                        <Select
                            value={(ops.plantTypes ?? []).find(obj => obj.value === ops.plantTypeId)}
                            options={ops.plantTypes}
                            onChange={(e) => {
                                ops.setPlantTypeId(e.value);
                            }}
                        />
                    </div>
                    <div style={{ minWidth: "350px" }}>
                        <label>Språk</label>
                        <div className="langs">
                            {ops.ALL_LANGUAGES.map((l: string) => (
                                <div key={l} className="lang">
                                    <input id={"lang-" + l} type="checkbox" checked={
                                        ops.selectedLanguages.indexOf(l) >= 0
                                    }
                                        onChange={e => ops.setLanguages(l)}
                                    />
                                    <label htmlFor={"lang-" + l}>{l}</label>
                                </div>
                            ))}

                        </div>
                    </div>
                    <div>

                        {/* Filter */}
                        <label>Filter</label>
                        <div className="buttonlist">
                            <button type="button" className="btn" onClick={() => ops.resetFilter()}>Ta bort filter</button>
                            {ops.ALL_LANGUAGES.filter(l => ops.selectedLanguages.indexOf(l) >= 0).map(lang => (
                                <button key={lang} className="btn" onClick={() => onShowNotTranslatedSnippets(lang as any)}>
                                    Saknar översättning ({lang})
                                </button>
                            ))}

                            {/* Export */}
                            {false && ops.ALL_LANGUAGES.filter(l => ops.selectedLanguages.indexOf(l) >= 0).map(lang => (
                                <button key={lang} type="button" className="btn" onClick={async () => {
                                    const url = "/api/translationplants/file/" + lang;
                                    window.open(url, "_blank");
                                    const js = await FetchHandler.getJson(url);
                                    console.log(js);
                                }}>
                                    Översättningsfil ({lang})
                                </button>
                            ))}

                        </div>

                        {/* Egen status */}
                        <label>
                            Egen status
                        </label>
                        <div className="status-buttons">
                            <div className={"status-button" + (ops.selectedStates.indexOf("none") >= 0 ? " selected" : "")} onClick={() => ops.setSelectedStates("none")}>
                                {TranslationStateTypeText.none}
                            </div>
                            <div className={"status-button" + (ops.selectedStates.indexOf("reviewed") >= 0 ? " selected" : "")} onClick={() => ops.setSelectedStates("reviewed")}>
                                {TranslationStateTypeText.reviewed}
                            </div>
                            <div className={"status-button" + (ops.selectedStates.indexOf("updated") >= 0 ? " selected" : "")} onClick={() => ops.setSelectedStates("updated")}>
                                {TranslationStateTypeText.updated}
                            </div>
                            <div className={"status-button" + (ops.selectedStates.indexOf("invalid") >= 0 ? " selected" : "")} onClick={() => ops.setSelectedStates("invalid")}>
                                {TranslationStateTypeText.invalid}
                            </div>
                        </div>

                        {/* Egen status */}
                        <label>
                            Översättningsstatus
                        </label>
                        <div className="status-buttons">
                            <div className={"status-button" + (ops.selectedTranslationStatus.indexOf("ok") >= 0 ? " selected" : "")} onClick={() => ops.setSelectedTranslationStatus("ok")}>
                                {TranslationStatusTypeText.ok}
                            </div>
                            <div className={"status-button" + (ops.selectedTranslationStatus.indexOf("needs_review") >= 0 ? " selected" : "")} onClick={() => ops.setSelectedTranslationStatus("needs_review")}>
                                {TranslationStatusTypeText.needs_review}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="toolbox" style={{
                    display: "block",
                    position: "sticky",
                    top: "0",
                    background: "white"
                }}>
                    <div style={{ minWidth: "350px" }}>
                        <label>Fält</label>
                        <div className="langs">
                            {ops.ALL_FIELDS.map((f: string) => {
                                const checked = ops.selectedFields.indexOf(f) >= 0;
                                return (
                                    <div key={f} className="lang">
                                        <input name="fields" id={"field-" + f} type="radio" checked={checked}
                                            onChange={e => ops.setSelectedFields(f)}
                                        />
                                        <label htmlFor={"field-" + f}>{ops.ALL_FIELDS_NAMES?.[f]}</label>
                                    </div>
                                )
                            })}

                        </div>
                        <span className="snippets-text">
                            Fält markerade med * är snippets.
                        </span>
                    </div>

                    {(Object.keys(ops.changes ?? {}).length + Object.keys(ops.snippetChanges ?? {}).length) > 0 && (
                        <div className="translation-save-button">
                            {/* <div>Det finns ändringar som inte sparats.</div> */}
                            <button type="button" className="btn" onClick={ops.saveChanges}>
                                <AdminIcon icon={AdminIcons.save} />
                                &nbsp;Spara förändringar
                            </button>
                            <button type="button" className="btn" onClick={ops.undoChanges}>
                                <AdminIcon icon={AdminIcons.save} />
                                &nbsp;Ångra  förändringar
                            </button>
                        </div>
                    )}
                </div>
                <hr />

                {/****************************************** TABLE *******************************************/}

                <div>
                    <div style={{ backgroundColor: "white" }}>
                        <Pager
                            currentPage={pageCurrentIndex + 1}
                            nextClicked={() => { setPageCurrentIndex(pageCurrentIndex + 1) }}
                            prevClicked={() => { setPageCurrentIndex(pageCurrentIndex - 1) }}
                            pageCount={totalPageCount}
                        />
                    </div>
                    <table className="tbl tbl-small translations tbl-translations">
                        <thead id="translations-tbl-header">
                            <tr>

                                {/* Plantfields */}
                                <th onClick={() => ops.setSort("name")}>Namn (SE)</th>
                                <th onClick={() => ops.setSort("specifictype")}>Sort (SE)</th>
                                {show_field_public_description && (<th onClick={() => ops.setSort("public_description")}>Beskrivning (SE)</th>)}

                                {/* Snippet */}
                                {show_field_snippet && (<th onClick={() => { }}>{ops.ALL_FIELDS_NAMES?.[ops.selectedFields?.[0]]} (SE)</th>)}

                                {ops.selectedLanguages?.map(lang => (
                                    <React.Fragment key={lang}>

                                        {/* Plantfields */}
                                        <Th visible={show_field_name} nameOfField={ops.ALL_FIELDS_NAMES?.name} language={lang} onClick={() => ops.setSort(lang + ".name")} />

                                        <Th visible={show_field_specifictype} nameOfField={ops.ALL_FIELDS_NAMES?.specifictype} language={lang}
                                            onClick={() => ops.setSort(lang + ".specifictype")} />

                                        <Th visible={show_field_public_description} nameOfField={ops.ALL_FIELDS_NAMES?.public_description} language={lang}
                                            onClick={() => ops.setSort(lang + ".public_description")}
                                        />

                                        {/* Snippet */}
                                        <Th visible={show_field_snippet} nameOfField={ops.ALL_FIELDS_NAMES?.[ops.selectedFields?.[0]]} language={lang} />

                                    </React.Fragment>
                                ))}





                            </tr>
                        </thead>
                        <tbody id="translations-tbl-body">
                            {visibleRows?.filter(m => !!m?.name).map(p => (
                                <tr key={p?.id} data-id={p?.id} className={!!ops.changes?.[p?.id] ? "changed" : ""}>
                                    {/* Plantfields */}
                                    <Td visible={true}>
                                        {p?.name}
                                    </Td>
                                    <Td visible={true}>
                                        {p?.specifictype}
                                    </Td>
                                    <Td visible={show_field_public_description} className="show-linebreaks">
                                        {p?.public_description}
                                    </Td>

                                    {/* Snippet */}
                                    <Td visible={show_field_snippet}>
                                        <SnippetsText id={(p as any)?.[ops.selected_snippet_fieldname]} db={ops.snippets} />
                                    </Td>


                                    {ops.selectedLanguages?.map(lang => {

                                        const snippetId = (p as any)?.[ops.selected_snippet_fieldname];
                                        const snippetDescriptionSe = ops.snippets[snippetId]?.snippetDescription;
                                        const language = lang as LanguageCodeType;

                                        return (

                                            <React.Fragment key={lang}>
                                                {/* Plantfields */}
                                                {/* Name */}
                                                <Td visible={show_field_name}>
                                                    <TranslationInput
                                                        value={p?.[lang]?.name}
                                                        onChange={e => ops.addUpdate(p?.id, lang as LanguageCodeType, "name", e)}
                                                        hasChanged={!!ops.changes?.[p?.id]?.[lang]?.name}
                                                        onUndo={() => ops.addUpdate(p?.id, lang as LanguageCodeType, "name", p?.[lang]?.name)}
                                                        onRemove={() => ops.addUpdate(p?.id, lang as LanguageCodeType, "name", "")}
                                                        hideTranslateButton={!p?.[lang]?.name}
                                                    />
                                                </Td>

                                                {/* Sort */}
                                                <Td visible={show_field_specifictype}>

                                                    <TranslationInput
                                                        value={p?.[lang]?.specifictype}
                                                        onChange={e => ops.addUpdate(p?.id, lang as LanguageCodeType, "specifictype", e)}
                                                        hasChanged={!!ops.changes?.[p?.id]?.[lang]?.specifictype}
                                                        onUndo={() => ops.addUpdate(p?.id, lang as LanguageCodeType, "specifictype", p?.[lang]?.specifictype)}
                                                        onRemove={() => ops.addUpdate(p?.id, lang as LanguageCodeType, "specifictype", "")}
                                                        hideTranslateButton={!p?.[lang]?.specifictype}

                                                    />
                                                </Td>

                                                {/* Description */}
                                                <Td visible={show_field_public_description}>

                                                    <div className="lang-name">Namn: <span>{p?.[lang]?.name}</span></div>
                                                    <TranslationInput
                                                        textarea={true}
                                                        value={p?.[lang]?.public_description} onChange={e => ops.addUpdate(p?.id, lang as LanguageCodeType, "public_description", e)}
                                                        hasChanged={!!ops.changes?.[p?.id]?.[lang]?.public_description}
                                                        onUndo={() => ops.addUpdate(p?.id, lang as LanguageCodeType, "public_description", p?.[lang as LanguageCodeType]?.public_description)}
                                                        onTranslate={async () => {
                                                            const options: TranslateTextObjType = {
                                                                id: "",
                                                                text: p?.public_description,
                                                                language: lang,
                                                                plantNameFrom: p?.name,
                                                                plantNameTo: p?.[lang]?.name
                                                            };
                                                            var ret = await ops.translateTextMultiple([options]);
                                                            return ret?.[0].translatedText;

                                                        }}
                                                        onRemove={() => ops.addUpdate(p?.id, lang as LanguageCodeType, "public_description", "")}
                                                        hideTranslateButton={!p?.public_description}


                                                    />
                                                    <div>


                                                        <div className="snippet-status-container" title={JSON.stringify(p?.[lang])}>
                                                            <div className="text">
                                                                <span className="bold">Översättningsstatus:</span>
                                                                {(p?.[lang] as any)?.public_description_translation_status}
                                                            </div>
                                                            <div className="text">
                                                                <span className="bold">fuzzyflags:</span>
                                                                {(p?.[lang] as any)?.public_description_fuzzyflags}
                                                            </div>
                                                            <div className="text">
                                                                <span className="bold">problems:</span>
                                                                {(p?.[lang] as any)?.public_description_problems}
                                                            </div>
                                                        </div>

                                                        <StateEditor
                                                            editable={true}
                                                            state={(p?.[lang] as any)?.public_description_state}
                                                            onSetState={e => {
                                                                ops.setFieldTranslationState(p?.id, "public_description", lang, e);
                                                            }} />

                                                    </div>
                                                </Td>

                                                {/* Snippet */}
                                                <Td visible={show_field_snippet}>

                                                    <div className="lang-name">Namn ({language}): <span>{p?.[language]?.name}</span> </div>
                                                    <TranslationInput
                                                        textarea={true}
                                                        value={
                                                            StringHelper.coalesce(
                                                                ops.snippetChanges?.[snippetId]?.[lang],
                                                                ops.snippets?.[snippetId]?.[language]
                                                            )
                                                        }

                                                        onChange={e => ops.addUpdateSnippet(snippetId, language, e)}
                                                        hasChanged={!!ops.snippetChanges?.[snippetId]?.[lang]}
                                                        onUndo={() => ops.addUpdateSnippet(snippetId, language, ops.snippets?.[snippetId]?.[language])}
                                                        onTranslate={async () => {

                                                            const options: TranslateTextObjType = {
                                                                id: "",
                                                                text: snippetDescriptionSe,
                                                                language: lang,
                                                                plantNameFrom: p?.name,
                                                                plantNameTo: p?.[lang]?.name
                                                            };
                                                            var ret = await ops.translateTextMultiple([options]);
                                                            return ret?.[0].translatedText;
                                                        }}
                                                        onRemove={async () => await ops.deleteTranslationSnippet(snippetId, language)}
                                                        hideTranslateButton={!snippetDescriptionSe}
                                                        snippetId={snippetId}

                                                    />
                                                    <SnippetStatus
                                                        value={
                                                            StringHelper.coalesce(
                                                                ops.snippetChanges?.[snippetId]?.[lang],
                                                                ops.snippets?.[snippetId]?.[language]
                                                            )
                                                        }
                                                        snippetId={snippetId}
                                                        language={language}
                                                        state={StringHelper.coalesce(ops.snippets?.[snippetId]?.[language + "_state"], "none") as any}
                                                        translationStatus={StringHelper.coalesce(ops.snippets?.[snippetId]?.[language + "_translation_status"], "none") as any}
                                                        fuzzyflags={ops.snippets?.[snippetId]?.[language + "_fuzzyflags"] as any}
                                                        problems={ops.snippets?.[snippetId]?.[language + "_problems"] as any}
                                                        onSetState={async e => ops.setSnippetTranslationState(snippetId, language, e)}
                                                    />

                                                </Td>
                                            </React.Fragment>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Pager
                        currentPage={pageCurrentIndex + 1}
                        nextClicked={() => { setPageCurrentIndex(pageCurrentIndex + 1) }}
                        prevClicked={() => { setPageCurrentIndex(pageCurrentIndex - 1) }}
                        pageCount={totalPageCount}
                    />

                </div>
            </form>
        </div>
    )
}
const SnippetStatus = ({ value, snippetId, language, state, translationStatus, fuzzyflags, problems, onSetState }:
    { value: string, snippetId: string, language: LanguageCodeType, state: TranslationStateType, translationStatus: TranslationStatusType, fuzzyflags: string, problems: string, onSetState?(e: TranslationStateType): void }) => {
    if (!snippetId) {
        return (null)
    }

    return (
        <div>
            <div className="snippet-status-container" data-state={state}>
                <div className="text">
                    <span className="bold">Översättningsstatus:</span>
                    {translationStatus}
                </div>
                <div className="text">
                    <span className="bold">fuzzyflags:</span>
                    {fuzzyflags}
                </div>
                <div className="text">
                    <span className="bold">problems:</span>
                    {problems}
                </div>
            </div>
            <StateEditor editable={!!value} state={state} onSetState={onSetState} />
        </div>
    )
}
const StateEditor = ({ state, onSetState, editable }: { state: TranslationStateType, onSetState(e: TranslationStateType): void, editable: boolean }) => {
    const _state: TranslationStateType = StringHelper.coalesce(state, "none") as TranslationStateType;
    return (
        <div className="snippet-status-container" data-state={state}>
            <div>
                {_state == "none" && (<div className="dot"></div>)}
                {_state == "updated" && (<div className="dot yellow"></div>)}
                {_state == "reviewed" && (<div className="dot green"></div>)}
                {_state == "invalid" && (<div className="dot red"></div>)}
            </div>


            <div className="text">
                Egen status:
                {_state == "none" && (<span>{TranslationStateTypeText.none}</span>)}
                {_state == "updated" && (<span>{TranslationStateTypeText.updated}</span>)}
                {_state == "reviewed" && (<span>{TranslationStateTypeText.reviewed}</span>)}
                {_state == "invalid" && (<span>{TranslationStateTypeText.invalid}</span>)}
            </div>

            {!!editable && (
                <div>
                    <button type="button" onClick={() => onSetState("none")}>Ingen</button>
                    <button type="button" onClick={() => onSetState("updated")}>Uppdaterad</button>
                    <button type="button" onClick={() => onSetState("reviewed")}>Godkänd</button>
                    <button type="button" onClick={() => onSetState("invalid")}>Ej godkänd</button>
                </div>
            )}

        </div>
    )
}
const Pager = ({ currentPage, pageCount, nextClicked, prevClicked, sticky }: { currentPage: number, pageCount: number, nextClicked(): void, prevClicked(): void, sticky?: string }) => {


    return (

        <div className="pager-container" style={(!!sticky ? {
            position: "sticky",
            top: sticky
        } : {})}>
            <div className="pager">
                <div onClick={prevClicked} className={"pager-btn" + (currentPage === 1 ? " disabled" : "")}>
                    <AdminIcon icon={AdminIcons.angle_double_left} />
                </div>
                <div>
                    {currentPage}/{pageCount}
                </div>
                <div onClick={nextClicked} className={"pager-btn" + (currentPage === pageCount ? " disabled" : "")}>
                    <AdminIcon icon={AdminIcons.angle_double_right} />
                </div>
            </div>
        </div>
    )
}

type TranslationInputType = {
    value: string,
    hasChanged: boolean,
    onChange(e: string): void,
    onUndo(): void,
    textarea?: boolean,
    onTranslate?(): Promise<string>,
    onRemove?(): void,
    hideTranslateButton: boolean
    snippetId?: string
}


const TranslationInput = ({ value, hasChanged, onChange, onUndo, onRemove, textarea, onTranslate, hideTranslateButton, snippetId }: TranslationInputType) => {

    const [_value, _setValue] = useState<string>(value);

    useEffect(() => {
        _setValue(value)
    }, [value]);

    const translateClick = async () => {
        const str = await onTranslate();
        _setValue(str ?? "");
        onChange(str);
    }

    const textChanged = e => {
        _setValue(e.target.value)
        onChange(e.target.value);
    }


    return (
        <div className="inp">

            {!!textarea && (
                <>
                    <textarea
                        className={"translation-input" + (hasChanged ? " changed-input" : "")}
                        value={_value ?? ""}
                        onChange={textChanged} />

                    {/* {(!_value && hideTranslateButton != true) && (
                        <button className="btn translation-button" onClick={translateClick} data-snippetid={snippetId}>Översätt</button>
                    )} */}
                </>
            )}
            {!textarea && (
                <input type="text"
                    className={"translation-input" + (hasChanged ? " changed-input" : "")}
                    value={_value}
                    onChange={textChanged} />
            )}


            <div className="input-buttons">

                {(!!_value && !!onRemove) && (
                    <button type="button" className="btn" onClick={() => {
                        onRemove();
                    }}>Radera</button>
                )}


                {hasChanged && (
                    <button type="button" className="btn" onClick={() => {
                        _setValue(value ?? "")
                        onUndo();
                    }}>Ångra</button>
                )}
            </div>
        </div>)


}


const Td = ({ visible, children, className }: { visible: boolean, children?: ReactNode, className?: string }) => {
    if (!visible) { return (null) }
    const cn = "";
    return (
        <td className={!!className ? (className + " " + cn) : cn}>
            {children}
        </td>
    )
}
const Th = ({ visible, children, nameOfField, language, onClick }: { visible: boolean, children?: ReactNode, nameOfField: string, language: string, onClick?(): void }) => {
    if (!visible) { return (null) }
    return (
        <th className="tbl-tr-th" onClick={onClick}>
            <span>{nameOfField} ({language})</span>
            {/* {children} */}
        </th>
    )
}

const SnippetsText = ({ id, db }: { id: string, db: Record<string, SnippetsType> }) => {
    return (
        <div>
            <div className="show-linebreaks">
                {db?.[id]?.snippetDescription}
            </div>
        </div>
    )
}
